export const styles = theme => ({
    paperWidthSm: {
        width: '60%',
        maxWidth: 'unset', 
    },
    // title: {
    //     '@media screen and (min-width: 1200px) and (max-width: 1920px)': {
    //         fontSize: 34,
    //         fontWeight: 500,
    //     },
    // },
    marginCloseButton: {
        marginTop: 4,
        minWidth: 45
    },
    rootDialogContent: {
        padding: '0% 3.8542%',
    },
    rootDialogActions: {
        margin: 0,
        position: 'absolute',
        top: '0%',
        right: '0%'
    },
    title: {
        padding: '2rem',
        fontSize: '1.2rem',
        fontWeight: '500'
    },
    inputPhoneNumber:{

        border: '1px solid #d2d2d2',
        margin: '0 2rem', 
        padding: '0.5rem',
        '&:after': {
            borderBottomColor: '#fff',
          },
        '&:hover&:after ': {
            borderBottomColor: '#fff',
            },
    }, 
    inputSearch:{ 
        border: '1px solid #d2d2d2',
        borderBottom: 'none',
        margin: '0 2rem', 
        padding: '0.6rem 1rem',
        '&:after': {
            borderBottomColor: '#fff',
          },
        '&:hover&:after ': {
            borderBottomColor: '#fff',
            },
    }, 
    topLevelCategoryContainer: {
        padding: '1rem',
        display: 'flex',
        alignItems: 'center'
    },
    childTitle: { 
        display: 'flex',
        fontSize: '1rem',
    },
    parentCategory: {
        paddingLeft: '2rem',
        paddingBottom: '0.5rem',
        paddingTop: '2rem',
        fontSize: '1rem',
    },
    rootList: {
        margin: '0 2rem 2rem 2rem',
        border: 'solid 2px #c1c1c18a',
        height: '30vw',
        overflow: 'auto'
    },
    containerButton: {
        display: 'flex',
        justifyContent: 'flex-end',
        padding: '0 2rem 2rem 2rem'
    },
    buttonCacel: {
        marginRight: '0.5rem'
    },
    listItem: {
        marginBottom: 8
    },
    listItemText: {
        paddingLeft: '0'
    },
    inputRoot: {
        paddingLeft: '2rem',
        position: 'absolute',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%'
    },
    CloseIcon: {
        height: '1.2rem',
        width: '1.2rem'
    }
    // cursor: 'pointer', 
    // paddingLeft: `${menuLevel*16}px`,
    // borderBottom: 'none', height: '3rem'
})